import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-theme-option-elements-chart-gauge-shadow-opacity',
  templateUrl: './theme-option-elements-chart-gauge-shadow-opacity.component.html',
  styleUrls: ['./theme-option-elements-chart-gauge-shadow-opacity.component.css']
})
export class ThemeOptionElementsChartGaugeShadowOpacityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
